module.exports = __webpack_public_path__ + "static/media/consent.fc60b937.png";